import "../layouts/css/Header.css";
import { Link } from "react-router-dom";
import logo from '../layouts/img/logo.png'

export default function Header() {
  return (
    <>
      <header>
        <nav id="nav" className="overflow">
          <div id="nav-div" className="width">
            <div id="div-logo">
              <Link to="/" id="logo-link"><img id="logo-img" src={logo} alt="NICA Logo" /></Link>
            </div>
            <div id="nav-buttons-div">
              <Link className="nav-buttons" to="/">Home</Link>
              <Link className="nav-buttons" to="/Bagni">Bagni provincia Torino</Link>
              <Link className="nav-buttons" to="/?scrollTo=last-back-img">Contatti</Link>
            </div>
          </div>
        </nav>
      </header>
    </>
  );
}
